// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {createCustomer} from '../../shared/repositories';
import productActions from '../../../product/actions-list';
import {successAlertBar} from '../../../shared/services/alert-bar';

export const createNewCustomer = (source, entityId) =>

    async dispatch => {

        if (source === 'customer-modal') {

            dispatch({
                isVisible: true,
                type: productActions.UPDATE_CUSTOMER_SEARCH_MODAL_VISIBILITY
            });

        }

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await createCustomer(entityId);

            dispatch({
                data,
                type: actions.CREATE_NEW_CUSTOMER_SUCCESS
            });

            successAlertBar('CUSTOMER_CREATED_SUCCESSFULLY');

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/customer/details/action-creators/create.js